<template>
  <div class="p-the-page-b01 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <div class="p-the-page-b01__body">
          <TheSideMenu
            :categories="categories"
            @click-subcategory="clickOnSubcategory($event)"
          >
            <TheB01SearchPanel
              v-model:search-from="searchFrom"
              v-model:search-to="searchTo"
              v-model:show-main-category-active="showMainCategoryActive"
              :current-category="currentCategory"
              :current-category-child="currentCategoryChild"
              :search-keyword="searchKeyword"
              :is-usable-range="isUsableRange"
              :max-point-searchable="maxPointSearchable"
              @min-max-form="minMaxfrom($event)"
              @click-subcategory-upper="clickOnUpperSubcategory($event)"
            />
          </TheSideMenu>
          <div class="p-the-page-b01__main">
            <div class="p-the-page-b01__header">
              <div class="p-the-page-b01__breadcrumb">
                <TheBreadcrumb />
              </div>
              <TitleLarge class="p-the-page-b01__header__name">
                {{ pageTitle }}
              </TitleLarge>
              <div class="p-the-page-b01__header__content">
                <div class="p-the-page-b01__header__content__info">
                  <span>検索結果</span>
                  <div class="p-the-page-b01__header__content__info__count">
                    <template v-if="haveItem">
                      <span>{{ totaCountString }}件({{ count }}件)</span>
                    </template>
                    <template v-else>
                      <span>0件</span>
                    </template>
                  </div>
                </div>
                <ButtonRefine
                  v-if="haveItem"
                  v-model:refine="sorted.target"
                  class="p-the-page-b01__header__content__sort_btn"
                  :heading="heading"
                  icon="sorted"
                  :refine-item-list="sorted.itemList"
                  :shown="sorted.shownState"
                  :width="'156px'"
                  @do-sort="doSort($event)"
                  @switch-refine-state="switchSortedState"
                />
              </div>
            </div>
            <template v-if="haveItem">
              <div class="p-the-page-b01__item_list">
                <ItemList :items="items" :add-to-browser-history="true" />
                <div class="p-the-page-b01__item_list__nav">
                  <PageNavi
                    :current-page="currentPage"
                    :max-page="maxPage"
                    :next-page-url="nextPageUrl"
                    :prev-page-url="prevPageUrl"
                    :base-url="baseUrl"
                  />
                </div>
              </div>
            </template>
            <template v-else>
              <CommonHeading class="p-the-page-b01__empty">
                <span class="p-the-page-b01__empty__text"
                  >ご指定の検索条件に該当する商品は</span
                >
                <br class="u-display-none--pc" />
                <span class="p-the-page-b01__empty__text"
                  >みつかりませんでした</span
                >
              </CommonHeading>
            </template>
            <template v-if="!haveItem">
              <template v-if="haveRecommendations">
                <div class="p-the-page-b01__block">
                  <ItemListHeading
                    title="おすすめの商品"
                    title-en="RECOMMENDED"
                  />
                  <div class="p-the-page-b01__item_list">
                    <ItemList :items="slicedRecommendations" />
                  </div>
                </div>
              </template>
              <template v-if="haveHistories">
                <div class="p-the-page-b01__block">
                  <ItemListHeading
                    title="最近チェックした商品"
                    title-en="RECENTRY VIEWED"
                  />
                  <div class="p-the-page-b01__item_list">
                    <ItemList :items="slicedHistories" />
                  </div>
                  <div class="p-the-page-b01__item_list__btn">
                    <ButtonMain tag="a" href="/f01/" kind="secondary"
                      >もっと見る</ButtonMain
                    >
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
      <TheFooter />
    </div>
  </div>
</template>

<script lang="ts">
import { mapState, mapActions } from "vuex";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheSideMenu from "@/general/components/organisms/TheSideMenu.vue";
import ItemListHeading from "@/common/components/atoms/ItemListHeading.vue";
import ItemList from "@/general/components/organisms/ItemList.vue";
import ButtonRefine from "@/common/components/atoms/ButtonRefine.vue";
import PageNavi from "@/common/components/atoms/PageNavi.vue";
import TitleLarge from "@/common/components/atoms/TitleLarge.vue";
import TheB01SearchPanel from "@/general/components/pages/parts/ProductList/TheB01SearchPanel.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import items from "@/general/store/modules/items";
import {
  getCategories,
  getCategoryById,
  getProductList,
  getUserProfileSummary,
  productSearch
} from "@/general/store/api";

import { karteView, karteCategory } from "@/common/assets/js/karte/";
import globals from "@/general/store/modules/globals";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheHeader,
    TheFooter,
    TheSideMenu,
    ItemListHeading,
    ItemList,
    ButtonRefine,
    PageNavi,
    TitleLarge,
    TheB01SearchPanel,
    TheBreadcrumb,
    ButtonMain,
    CommonHeading
  }
})
export default class ProductList extends Vue {
  currentCategory: any = {
    label: "",
    children: []
  };

  currentCategoryChild = {
    id: 1,
    label: "調理器具"
  };
  searchFrom!: any;
  searchTo!: any;
  maxPointSearchable = 50500;
  searchKeyword = "";
  haveItem = false;
  isUsableRange = false;

  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };

  breadcrumb: any = [];

  currentPage = 0;

  sorted = {
    target: "並び替え",
    shownState: false,
    itemList: [
      {
        id: "sorted-popular",
        value: "popularity",
        label: "人気順"
      },
      {
        id: "sorted-new",
        value: "new_arrival",
        label: "新着順"
      },
      {
        id: "sorted-point-asc",
        value: "point_low_to_high",
        label: "ポイント低い順"
      },
      {
        id: "sorted-point-desc",
        value: "point_high_to_low",
        label: "ポイント高い順"
      }
    ]
  };

  items: any = [];
  recommendations = items.recommendations;
  histories = items.histories;
  unit = commons.OrgPageSpecific?.point_name;

  categories: any = [];

  categoryName = "";

  count = 0;

  startPage = 0;
  endPage = 0;

  searchParam = "";

  showMainCategoryActive = false;

  declare $refs: {
    theHeader: TheHeader;
  };

  get haveRecommendations() {
    return this.recommendations.length > 0;
  }
  get haveHistories() {
    return this.histories.length > 0;
  }
  get slicedRecommendations() {
    return this.recommendations.slice(0, 4);
  }
  get slicedHistories() {
    return this.histories.slice(0, 4);
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get pageTitle() {
    const defaultName = "全ての商品"; // "全て";
    if (this.searchKeyword) {
      return `“${this.searchKeyword.replace(/\s+/g, ", ")}”`;
    } else if (this.categoryName !== "") {
      return `“${this.categoryName}”`;
    } else {
      return `“${defaultName}”`;
    }
  }


  get pageSize() {
    return 80;
  }

  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }
  get heading() {
    const index = this.sorted.itemList.findIndex(
      (p) => p.value == this.sorted.target
    );

    if (index != -1) {
      return this.sorted.itemList[index].label;
    } else {
      return "並び替え";
    }
  }

  get totaCountString() {
    return this.count < 1
      ? "0~0"
      : `${this.getStartItemNumber()}〜${this.getEndItemNumber()}`;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const checkUserPointsDetails = LocalStorage.getItem("userPointsDetails");

    if (checkUserPointsDetails === null) {
      this.getUserPoints();
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const searchParam = urlParams.get("product-search")
      ? (urlParams.get("product-search") as string)
      : undefined;

    let categoryParam = urlParams.get("product-category")
      ? (urlParams.get("product-category") as string)
      : undefined;

    const productStatus = urlParams.get("product-status")
      ? (urlParams.get("product-status") as string)
      : undefined;

    const premiums = urlParams.get("premiums")
      ? (urlParams.get("premiums") as string)
      : undefined;

    if (categoryParam !== undefined) {
      LocalStorage.setItem(
        "productListSelectedCategory",
        categoryParam.toString()
      );

      const catName = await getCategoryById(parseInt(categoryParam, 10));

      if (catName && searchParam !== undefined) {
        this.categoryName = searchParam + "," + catName?.name;
      } else {
        this.categoryName = catName?.name;
      }

      let subcategories: any = [];

      if (catName?.level && catName.level == 1) {
        this.showMainCategoryActive = true;
        subcategories = catName.sub_categories;
      } else {
        subcategories = this.getSubcategoriesByMainCategoryId(
          catName?.main_category.id
        );

        this.currentCategoryChild = {
          id: catName.id,
          label: catName.name
        };
      }

      subcategories.forEach((subCat: any) => {
        this.currentCategory.children.push({
          id: subCat.id,
          label: subCat.name
        });
      });

      karteCategory(catName);
    } else {
      categoryParam = undefined;
      this.categoryName = "全ての商品";
      LocalStorage.removeItem("productListSelectedCategory");
    }

    const pageParam = urlParams.get("page");
    this.currentPage = pageParam ? parseInt(pageParam) : 1;

    const max = LocalStorage.getItem("poductListMaxPoint")
      ? parseInt(LocalStorage.getItem("poductListMaxPoint") as string)
      : undefined;
    const min = LocalStorage.getItem("poductListMinPoint")
      ? parseInt(LocalStorage.getItem("poductListMinPoint") as string)
      : undefined;

    const sort = LocalStorage.getItem("productListSort")
      ? (LocalStorage.getItem("productListSort") as string)
      : "";

    const usableRange = LocalStorage.getItem("usableRange")
      ? LocalStorage.getItem("usableRange")
      : "";

    min && usableRange == "" ? (this.searchFrom = min) : "";
    max && usableRange == "" ? (this.searchTo = max) : "";

    this.breadcrumb = [
      {
        text: "",
        url: "/home",
        pageType: "home"
      },
      {
        text: "商品一覧",
        url: "",
        pageType: "lower"
      }
    ];

    let products: any = [];

    if (searchParam !== undefined) {
      LocalStorage.setItem("productListSearch", searchParam);

      this.searchKeyword = searchParam;
      this.searchParam = searchParam;

      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: "商品一覧",
          url: "/product-list/",
          pageType: "lower"
        },
        {
          text: searchParam,
          url: "",
          pageType: "lower"
        }
      ];

      products = await productSearch(
        this.currentPage,
        this.pageSize,
        sort,
        min,
        max,
        categoryParam,
        searchParam,
        premiums
      );
    } else {
      LocalStorage.removeItem("productListSearch");
      products = await getProductList(
        this.currentPage,
        this.pageSize,
        sort,
        min,
        max,
        categoryParam,
        productStatus,
        premiums
      );
    }

    this.items = products.results;

    this.count = products?.count ?? 1;

    this.categories = this.getLocalCategories();

    if (this.count >= 1) {
      this.haveItem = true;
      this.setPagination(this.count);

      if (searchParam === undefined && categoryParam === undefined) {
        this.currentCategory.label = "全て";
      } else if (searchParam === undefined && categoryParam === "") {
        this.currentCategory.label = "全て";
      } else if (searchParam !== undefined && categoryParam !== undefined) {
        const catIds = this.getRelatedCategories(this.items);
        if (catIds.length > 0) {
          this.getCategoryParentId(catIds[0]);
        }
      } else if (
        searchParam === undefined &&
        categoryParam !== undefined &&
        categoryParam !== ""
      ) {
        const catIds = this.getRelatedCategories(this.items);
        if (catIds.length > 0) {
          this.getCategoryParentId(catIds[0]);
        }
      } else {
        this.currentCategory.label = "全て";
      }
    }

    await commons.setbreadcrumb(this.breadcrumb);
  }

  async doSort(sort: any) {
    LocalStorage.setItem("productListSort", sort);
    const category = LocalStorage.getItem("productListSelectedCategory")
      ? (LocalStorage.getItem("productListSelectedCategory") as string)
      : undefined;

    const max = LocalStorage.getItem("poductListMaxPoint")
      ? parseInt(LocalStorage.getItem("poductListMaxPoint") as string)
      : undefined;
    const min = LocalStorage.getItem("poductListMinPoint")
      ? parseInt(LocalStorage.getItem("poductListMinPoint") as string)
      : undefined;

    const search = LocalStorage.getItem("productListSearch")
      ? (LocalStorage.getItem("productListSearch") as string)
      : undefined;

    const products = await productSearch(
      this.currentPage,
      this.pageSize,
      sort,
      min,
      max,
      category,
      search,
      undefined
    );
    this.items = products.results;

    this.count = products?.count ?? 1;

    if (this.count >= 1) {
      this.haveItem = true;
    } else {
      this.haveItem = false;
    }

    this.setPagination(this.count);
  }

  switchSortedState(value: any) {
    this.sorted.shownState = value;
  }

  async minMaxfrom(e: any) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");

    this.currentPage = pageParam ? parseInt(pageParam) : 1;

    const sort = LocalStorage.getItem("productListSort")
      ? (LocalStorage.getItem("productListSort") as string)
      : "";

    const category = LocalStorage.getItem("productListSelectedCategory")
      ? (LocalStorage.getItem("productListSelectedCategory") as string)
      : undefined;

    const search = LocalStorage.getItem("productListSearch")
      ? (LocalStorage.getItem("productListSearch") as string)
      : undefined;

    LocalStorage.setItem("poductListMaxPoint", e.max);
    LocalStorage.setItem("poductListMinPoint", e.min);

    const products = await productSearch(
      this.currentPage,
      this.pageSize,
      sort,
      e.min,
      e.max,
      category,
      search,
      undefined
    );
    this.items = products.results;
    this.count = products?.count ?? 0;
    if (this.count >= 1) {
      this.haveItem = true;
    } else {
      this.haveItem = false;
    }
    this.setPagination(this.count);
  }

  async clickOnSubcategory(id: number) {
    this.searchParam = "";
    LocalStorage.setItem("productListSelectedCategory", id.toString());
    this.currentCategoryChild.id = id;

    const sort = LocalStorage.getItem("productListSort")
      ? (LocalStorage.getItem("productListSort") as string)
      : "";

    const max = LocalStorage.getItem("poductListMaxPoint")
      ? parseInt(LocalStorage.getItem("poductListMaxPoint") as string)
      : undefined;
    const min = LocalStorage.getItem("poductListMinPoint")
      ? parseInt(LocalStorage.getItem("poductListMinPoint") as string)
      : undefined;

    LocalStorage.removeItem("productListSearch");

    const category = await getCategoryById(id);
    karteCategory(category);

    let subcategories: any = [];

    if (category?.level && category.level == 1) {
      this.showMainCategoryActive = true;
      subcategories = category.sub_categories;

      this.searchKeyword = category.name;
      this.categoryName = category?.name;
      this.currentCategory.label = category?.name;

      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: category?.name,
          url: "",
          pageType: "lower"
        }
      ];
    } else {
      this.currentCategory.label = category?.main_category?.name;
      subcategories = this.getSubcategoriesByMainCategoryId(
        category?.main_category.id
      );

      this.currentCategoryChild = {
        id: category.id,
        label: category.name
      };

      this.categoryName = category?.main_category?.name + "," + category?.name;
      // this.searchKeyword = category?.main_category?.name + "," + category?.name;
      this.searchKeyword = category?.name;

      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: category?.main_category?.name,
          url: "/product-list/?product-category=" + category?.main_category?.id,
          pageType: "lower"
        },
        {
          text: category?.name,
          url: "",
          pageType: "lower"
        }
      ];
    }

    this.currentCategory.children = [];

    subcategories.forEach((subCat: any) => {
      this.currentCategory.children.push({
        id: subCat.id,
        label: subCat.name
      });
    });

    // this.searchKeyword = this.searchParam;

    await commons.setbreadcrumb(this.breadcrumb);

    this.currentPage = 1;
    const products = await productSearch(
      this.currentPage,
      this.pageSize,
      sort,
      min,
      max,
      id + "",
      undefined,
      undefined
    );
    this.items = products.results;

    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }

    const nextPage = this.currentPage + 1;
    this.count = products?.count ?? 1;
    if (this.count >= 1) {
      this.haveItem = true;
    } else {
      this.haveItem = false;
    }

    this.setPagination(this.count);
  }

  async clickOnUpperSubcategory(id: number) {
    const sort = LocalStorage.getItem("productListSort")
      ? (LocalStorage.getItem("productListSort") as string)
      : "";

    const max = LocalStorage.getItem("poductListMaxPoint")
      ? parseInt(LocalStorage.getItem("poductListMaxPoint") as string)
      : undefined;
    const min = LocalStorage.getItem("poductListMinPoint")
      ? parseInt(LocalStorage.getItem("poductListMinPoint") as string)
      : undefined;

    const search = LocalStorage.getItem("productListSearch")
      ? (LocalStorage.getItem("productListSearch") as string)
      : undefined;

    LocalStorage.setItem("productListSelectedCategory", id.toString());

    const category = await getCategoryById(id);
    karteCategory(category);

    this.currentCategoryChild.id = id;
    if (category?.level == 2) {
      //this.categoryName = category?.main_category?.name + "," + category?.name;
      this.searchKeyword = this.searchParam;
      if (search !== undefined) {
        //this.searchKeyword = search + "," + category?.main_category?.name + "," + category?.name;
        this.searchKeyword = category?.name;
      } else {
        // this.searchKeyword =
        //   category?.main_category?.name + "," + category?.name;

        this.searchKeyword = category?.name;
      }

      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: category?.main_category?.name,
          url: "/product-list/?product-category=" + category?.main_category?.id,
          pageType: "lower"
        },
        {
          text: category?.name,
          url: "",
          pageType: "lower"
        }
      ];
    } else {
      this.categoryName = category?.name;
      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: category?.name,
          url: "",
          pageType: "lower"
        }
      ];
    }

    await commons.setbreadcrumb(this.breadcrumb);

    this.currentPage = 1;
    const products = await productSearch(
      this.currentPage,
      this.pageSize,
      sort,
      min,
      max,
      id + "",
      search,
      undefined
    );

    this.items = products.results;

    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }

    const nextPage = this.currentPage + 1;
    this.count = products?.count ?? 1;
    if (this.count >= 1) {
      this.haveItem = true;
    } else {
      this.haveItem = false;
    }

    this.setPagination(this.count);
  }

  async getCategoryParentId(id: number) {
    const sort = LocalStorage.getItem("productListSort")
      ? (LocalStorage.getItem("productListSort") as string)
      : "";

    const category = await getCategoryById(id);
    if (category?.level == 2) {
      this.currentCategory.label = category?.main_category?.name;
      //this.categoryName = category?.main_category?.name + "," + category?.name;
      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: category?.main_category?.name,
          url: "/product-list/?product-category=" + category?.id,
          pageType: "lower"
        },
        {
          text: category?.name,
          url: "",
          pageType: "lower"
        }
      ];
    } else {
      this.currentCategory.label = category?.name;
      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: category?.name,
          url: "",
          pageType: "lower"
        }
      ];
    }
  }

  setPagination(rowCount: number) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const search = LocalStorage.getItem("productListSearch")
      ? (LocalStorage.getItem("productListSearch") as string)
      : "";

    const category = LocalStorage.getItem("productListSelectedCategory")
      ? LocalStorage.getItem("productListSelectedCategory")
      : "";

    const productStatus = urlParams.get("product-status")
      ? (urlParams.get("product-status") as string)
      : undefined;

    const productCategory = urlParams.get("product-category")
      ? (urlParams.get("product-category") as string)
      : undefined;

    let link = "/product-list/?";

    if (search !== "") {
      link += "&product-search=" + search + "&";
    }

    if (productStatus !== undefined) {
      link += "&product-status=" + productStatus + "&";
    }

    if (productCategory !== undefined) {
      link += "&product-category=" + productCategory + "&";
    }

    const maxPage =
      rowCount % this.pageSize >= 1
        ? Math.floor(rowCount / this.pageSize) + 1
        : rowCount / this.pageSize;

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = link;
    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }
    const nextPage = this.currentPage + 1;

    this.pageNavi.nextPageUrl = this.pageNavi.baseUrl + "page=" + nextPage;

    this.pageNavi.prevPageUrl = this.pageNavi.baseUrl + "page=" + prevPage;
  }

  async getUserPoints() {
    const userPointsDetails = await getUserProfileSummary();
    LocalStorage.setItem(
      "userPointsDetails",
      JSON.stringify(userPointsDetails)
    );
  }

  getRelatedCategories(items: any) {
    let categoryIds = items.map((item: any) =>
      item.premium.categories.toString()
    );
    categoryIds = categoryIds.filter(
      (v: any, i: any, a: any) => a.indexOf(v) === i
    );

    return categoryIds;
  }

  getLocalCategories() {
    const categories = LocalStorage.getItem("categories") as string;
    return JSON.parse(categories);
  }

  getLocalCategorByid(id: any) {
    let categories: any = LocalStorage.getItem("categories") as string;
    categories = JSON.parse(categories);

    let ct: any = {};

    const id2 = parseInt(id);

    categories.forEach((item: any) => {
      if (item.id === id2) {
        ct = { id: item.id, name: item.name };
      } else {
        item?.sub_categories.forEach((ele: any) => {
          if (ele.id === id2) {
            ct = { id: ele.id, name: ele.name };
          }
        });
      }
    });
    return ct;
  }

  getStartItemNumber() {
    if (this.currentPage == 1) {
      return 1;
    } else {
      return (this.currentPage - 1) * this.pageSize + 1;
    }
  }

  getEndItemNumber() {
    if (this.currentPage == 1) {
      return this.items.length;
    } else {
      return this.getStartItemNumber() - 1 + parseInt(this.items.length);
    }
  }

  getSubcategoriesByMainCategoryId(id: number) {
    const categories = LocalStorage.getItem("categories") as string;
    const catJson = JSON.parse(categories);

    const subcategories = catJson.find((item: any) => item.id == id);

    return subcategories.sub_categories;
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-b01 {
  background-color: $common-bg;

  &__body {
    display: flex;
    justify-content: space-between;

    @include large-sp {
      display: block;
    }
  }

  &__main {
    flex: 1;
    padding: rem(12) 0 rem(56) rem(32);

    @include large-sp {
      padding: rem(12) 0 rem(40);
    }
  }

  &__header {
    &__name {
      margin-top: rem(32);

      @include large-sp {
        margin-top: 0;
      }
    }

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: rem(8);

      @include large-sp {
      }

      &__info {
        @include text__body--m;
        font-weight: bold;
        color: $common-black-sub;
        display: flex;
        align-items: center;

        @include large-sp {
          @include text__body--s;
        }

        &__count {
          margin-left: rem(16);

          @include large-sp {
            margin-left: rem(4);
          }
        }
      }

      &__sort_btn {
        width: rem(120);
      }
    }
  }

  &__empty {
    text-align: center;
    margin: rem(64) 0 rem(80);

    @include large-sp {
      margin: rem(56) 0;
    }

    &__text {
      @include large-pc {
        &:last-of-type {
          margin-left: rem(-2);
        }
      }
    }
  }

  &__block {
    margin-top: rem(56);

    @include large-sp {
      margin-top: rem(40);
    }

    &:first-of-type {
      margin-top: 0;
    }
  }

  &__item_list {
    margin-top: rem(32);

    @include large-sp {
      margin-top: rem(16);
    }

    &__btn {
      display: flex;
      justify-content: center;
      margin-top: rem(32);
    }

    &__nav {
      margin-top: rem(40);

      @include large-sp {
        margin-top: rem(32);
      }
    }
  }
}
</style>
